var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomer = function SvgCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#customer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.6,
    d: "M38.75 21a15.75 15.75 0 1 0-15.74 15.75"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.3,
    d: "M16.75 17.5h.017M29.25 17.5h.017"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.6,
    d: "M18.625 24.25a6.127 6.127 0 0 0 8.75 0M35.25 39.375a8.31 8.31 0 0 1 6.125-6.125 8.31 8.31 0 0 1-6.125-6.125 8.31 8.31 0 0 1-6.125 6.125 8.31 8.31 0 0 1 6.125 6.125"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "customer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgCustomer;